import { useContext, useEffect, useState } from "react";
import { ClientAddUpdate } from "./Service/TaskService";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../App";

const initialFormState = {
  id: 0,
  name: "",
  type: "",
  email: "",
  contact: "",
  primaryContact: "",
  primaryContactDesignation: "",
  primaryContactEmail: "",
  primaryContactPhone: "",
  website: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  countryId: 0,
};

const AddClient = ({ isOpen, onClose, onSave, editClientDetails }) => {
  const [clientForm, setClientForm] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [clientTypeList, setClientTypeList] = useState([]);
  const [countryList, setCountryList] = useState([]); 
  const userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);


  useEffect(() => {
    if (isOpen) {
      getCountryList();
    }
  }, [isOpen]);


  useEffect(() => {
    if (!isOpen) return;
    setLoading(false);
    if (editClientDetails && editClientDetails?.Id > 0) {
      // EDIT MODE
      setClientForm({
        id: editClientDetails?.Id || 0,
        name: editClientDetails?.ClientName || "",
        type: editClientDetails?.ClientTypeId || "",
        email: editClientDetails?.Email || "",
        contact: editClientDetails?.Phone || "",
        primaryContact: editClientDetails?.PrimaryContact || "",
        primaryContactDesignation:
          editClientDetails?.PrimaryContactDesignation || "",
        primaryContactEmail: editClientDetails?.PrimaryContactEmail || "",
        primaryContactPhone: editClientDetails?.PrimaryContactPhone || "",
        website: editClientDetails?.Website || "",
        address: editClientDetails?.Address || "",
        city: editClientDetails?.City || "",
        state: editClientDetails?.State || "",
        zip: editClientDetails?.Zip || "",
        countryId: editClientDetails?.CountryId || 0,
      });
    } else {
      // ADD MODE
      setClientForm(initialFormState);
      setErrors({});
    }
  }, [isOpen, editClientDetails]);

  const handleClose = () => {
    onClose();
  };

  const getCountryList = async () => {
    try {
      const params = {
        organisationId: userDetails?.OrgId,
        masterType: "Countries",
      };

      const response = await GetMasterTypeData(params);

      setCountryList(response?.Data || []);
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");
    }
  };


  const handleInputChange = (field, value) => {
    let maskedValue = value;

    // Only digits allowed for phone/contact fields
    if (["contact", "primaryContactPhone"].includes(field)) {
      maskedValue = value.replace(/\D/g, "").slice(0, 15); // digits only, max 15
    }

    setClientForm((prev) => ({ ...prev, [field]: maskedValue }));

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };


  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    if (!clientForm.name.trim())
      newErrors.name = "Company name is required";

    if (!clientForm.email.trim())
      newErrors.email = "Email is required";
    else if (!emailRegex.test(clientForm.email))
      newErrors.email = "Invalid email address";

    if (!clientForm.contact.trim())
      newErrors.contact = "Contact number is required";
    else if (!/^[0-9]{10,15}$/.test(clientForm.contact))
      newErrors.contact = "Must be 10 digits";

    // Primary contact email — only validate if filled
    if (clientForm.primaryContactEmail && !emailRegex.test(clientForm.primaryContactEmail))
      newErrors.primaryContactEmail = "Invalid email address";

    // Primary contact phone — only validate if filled
    if (clientForm.primaryContactPhone && !/^[0-9]{10,15}$/.test(clientForm.primaryContactPhone))
      newErrors.primaryContactPhone = "Must be 10 digits";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSave = async () => {

    if (!validateForm()) return;

    setLoading(true);
    try {
      const payload = {
        Id: clientForm.id || 0,
        Name: clientForm.name,
        PrimaryContact: clientForm.primaryContact,
        PrimaryContactDesignation: clientForm.primaryContactDesignation,
        Email: clientForm.email,
        PrimaryContactEmail: clientForm.primaryContactEmail,
        PrimaryContactPhone: clientForm.primaryContactPhone,
        Website: clientForm.website,
        Address: clientForm.address,
        City: clientForm.city,
        State: clientForm.state,
        Zip: clientForm.zip,
        CountryId: Number(clientForm.countryId),
        Phone: clientForm.contact,
      };

      const response = await ClientAddUpdate(payload);
      if (response?.Success || response?.StatusCode === 2000) {
        onSave?.();
        handleClose();
        toster.current.success(response.Data?.Message || "Client saved successfully");

      } else {
        toster.current.error(response.Data?.Message ||"Failed to save client");

      }
    } catch (error) {
      toster.current.error(error.response.Data?.Message || "somthing went wrong");

    } finally {
      setLoading(false);
    }
  };

  // =========================
  // CLOSE MODAL
  // =========================
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="mo-tm" onclick={handleOverlayClick}>
      <div className="mb" style={{ width: "700px" }}>
        {/* Header */}
        <div className="mh">
          <div
            style={{
              width: 28,
              height: 28,
              background: "var(--brand-soft)",
              borderRadius: 7,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--brand)",
            }}
          >
            <i className="fa-solid fa-building"></i>
          </div>

          <h5>{editClientDetails?.Id > 0 ? "Edit Client" : "New Client"}</h5>

          <button className="btn btn-ghost btn-icon mla" onClick={handleClose}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        {/* Body */}
        <div className="mbody">
          <div className="row">
            {/* Company Name */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">
                  Company Name <i className="inValidError">*</i>
                </label>

                <input
                  type="text"
                  className={`fc ${errors.name ? "is-invalid" : ""}`}
                  value={clientForm.name}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                />

                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>
            </div>

            {/* Client Type */}
            {/* <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">
                  Client Type{" "}
                  <i className="inValidError">*</i>
                </label>

                <select
                  className={`fs ${errors.type ? "is-invalid" : ""}`}
                  value={clientForm.type}
                  onChange={(e) =>
                    handleInputChange("type", e.target.value)
                  }
                >
                  <option value="">Select Type</option>

                  {clientTypeList.map((item) => (
                    <option
                      key={item?.Id}
                      value={item?.Id}
                    >
                      {item?.Name}
                    </option>
                  ))}
                </select>

                {errors.type && (
                  <div className="invalid-feedback">
                    {errors.type}
                  </div>
                )}
              </div>
            </div> */}

            {/* Email */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">
                  Email <i className="inValidError">*</i>
                </label>

                <input
                  type="email"
                  className={`fc ${errors.email ? "is-invalid" : ""}`}
                  value={clientForm.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                />

                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>
            </div>

            {/* Contact */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">
                  Contact <i className="inValidError">*</i>
                </label>

                <input
                  type="text"
                  className={`fc ${errors.contact ? "is-invalid" : ""}`}
                  value={clientForm.contact}
                  onChange={(e) => handleInputChange("contact", e.target.value)}
                />



                {errors.contact && (
                  <div className="invalid-feedback">{errors.contact}</div>
                )}
              </div>
            </div>

            {/* Divider */}
            <div className="col-md-12 mb-3 mt-4">
              <p className="division">Primary Details</p>
            </div>

            {/* Primary Contact */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">Primary Contact</label>

                <input
                  type="text"
                  className="fc"
                  value={clientForm.primaryContact}
                  onChange={(e) =>
                    handleInputChange("primaryContact", e.target.value)
                  }
                />
              </div>
            </div>

            {/* Designation */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">Contact Designation</label>

                <input
                  type="text"
                  className="fc"
                  value={clientForm.primaryContactDesignation}
                  onChange={(e) =>
                    handleInputChange(
                      "primaryContactDesignation",
                      e.target.value,
                    )
                  }
                />
              </div>
            </div>

            {/* Primary Email */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">Contact Email</label>

                <input
                  type="email"
                  className={`fc ${errors.primaryContactEmail ? "is-invalid" : ""
                    }`}
                  value={clientForm.primaryContactEmail}
                  onChange={(e) =>
                    handleInputChange("primaryContactEmail", e.target.value)
                  }
                />

                {errors.primaryContactEmail && (
                  <div className="invalid-feedback">
                    {errors.primaryContactEmail}
                  </div>
                )}
              </div>
            </div>

            {/* Contact Phone */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">Contact Phone</label>
                <input
                  type="text"
                  className={`fc ${errors.primaryContactPhone ? "is-invalid" : ""}`}
                  value={clientForm.primaryContactPhone}
                  onChange={(e) => handleInputChange("primaryContactPhone", e.target.value)}
                />
                {errors.primaryContactPhone && (
                  <div className="invalid-feedback">{errors.primaryContactPhone}</div>
                )}
              </div>
            </div>

            {/* Divider */}
            <div className="col-md-12 mb-3 mt-4">
              <p className="division">Other Details</p>
            </div>

            {/* Website */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">Website</label>

                <input
                  type="text"
                  className={`fc ${errors.website ? "is-invalid" : ""}`}
                  value={clientForm.website}
                  onChange={(e) => handleInputChange("website", e.target.value)}
                />

                {errors.website && (
                  <div className="invalid-feedback">{errors.website}</div>
                )}
              </div>
            </div>

            {/* Address */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">Address</label>

                <input
                  type="text"
                  className="fc"
                  value={clientForm.address}
                  onChange={(e) => handleInputChange("address", e.target.value)}
                />
              </div>
            </div>

            {/* City */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">City</label>

                <input
                  type="text"
                  className="fc"
                  value={clientForm.city}
                  onChange={(e) => handleInputChange("city", e.target.value)}
                />
              </div>
            </div>

            {/* State */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">State</label>

                <input
                  type="text"
                  className="fc"
                  value={clientForm.state}
                  onChange={(e) => handleInputChange("state", e.target.value)}
                />
              </div>
            </div>

            {/* Zip */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">Zip</label>

                <input
                  type="text"
                  className="fc"
                  value={clientForm.zip}
                  onChange={(e) => handleInputChange("zip", e.target.value)}
                />
              </div>
            </div>

            {/* Country */}
            <div className="col-md-6">
              <div className="mb-3">
                <label className="fl">Country</label>

                <select
                  className="fs"
                  value={clientForm.countryId}
                  onChange={(e) =>
                    handleInputChange("countryId", e.target.value)
                  }
                >
                  <option value="">Select Country</option>

                  {countryList.map((country) => (
                    <option key={country?.Id} value={country?.Id}>
                      {country?.Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mfoot">
          <button className="btn btn-outline" onClick={handleClose}>
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-brand"
            onClick={handleSave}
            disabled={loading}
          >
            {loading
              ? "Saving..."
              : editClientDetails?.Id > 0
                ? "Update Client"
                : "Save Client"}
          </button>
        </div>
      </div>
    </div>

  );
};

export default AddClient;
